// extracted by mini-css-extract-plugin
export var pillWrapper = "_os-0";
export var showOverflow = "_os-1";